import { PublicClientApplication, Configuration } from "@azure/msal-browser";


// Centralized API base URL configuration
// Dynamically set based on the current domain
const getApiBaseUrl = (): string => {
  const hostname = window.location.hostname;

  if (hostname.includes("targetquest.int.bayer.com")) {
    return "https://targetx.targetquest.int.bayer.com";
  } else if (hostname.includes("powerml.int.bayer.com")) {
    return "https://tesstarget.sbx.powerml.int.bayer.com";
  }

  // Default fallback
  return "https://targetx.targetquest.int.bayer.com";
};

export const API_BASE_URL = getApiBaseUrl();

// true when running via `npm run dev` or local Docker (localhost / 127.0.0.1)
export const isLocalDev = ["localhost", "127.0.0.1"].includes(window.location.hostname);

// Hubble literature search URL
export const HUBBLE_LITERATURE_URL =
  "https://search.hubble.int.bayer.com/detail/literature/?id=";

const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_MSAL_TENANT_ID || 'common'}`,
    redirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};
  
export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ["User.Read", "openid", "profile"],
};